import type { RefObject } from 'react';
// import { fadeTo } from 'util/animation/fade/fade';
import { revealRectangle } from '../../../util/animation/reveal/reveal';

interface OfficeOverviewRefs {
  // elementRef: RefObject<HTMLElement>;
  titleRef?: RefObject<HTMLHeadingElement | null>;
  imageHolderRef?: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { imageHolderRef }: OfficeOverviewRefs,
): void {
  // const titleController = findTransitionController(titleRef);

  if (imageHolderRef?.current) {
    timeline.add(revealRectangle(imageHolderRef.current), 0);
  }

  timeline.addLabel('startText', '>-0.2');
  // timeline.add(titleController?.getTimeline('in') as gsap.core.Timeline, 'startText+=0.1');
}

// export function setupTransitionOutTimeline(
//   timeline: gsap.core.Timeline,
//   { elementRef }: OfficeOverviewRefs,
// ): void {
//   timeline.add(fadeTo(elementRef.current as HTMLElement));
// }
